import InfoWindowMixin from '@/mixins/InfoWindowMixin'
import LocationMapPolygonService from '@/services/LocationMapPolygonService'
import LocationMapService from '@/services/LocationMapService'
import PolylineHelper from '@/utils/PolylineHelper'
import UniqueIdHelper from '@/utils/UniqueIdHelper'

export default {
  mixins: [InfoWindowMixin],

  props: {
    polygonParentAttribute: String,
    polygonParentId: String,
  },
  data() {
    return {
      polylines: new Map(),
      hoverPolylines: new Map(),
    }
  },
  methods: {
    initializePolygonEventListeners() {
      this.registerListener('polygon-load', (event) => {
        this.loadPolylines(event.data)
      })
      // enable showing recently added polygons
      this.registerListener('polygon-saved', (event) => {
        this.addPolyline(
          event.data.id,
          PolylineHelper.getPolyline(event.data.coordinates),
          event.data.color,
        )
      })
      // enable showing recently edited polygons
      this.registerListener('polygon-edited', (event) => {
        this.addPolyline(
          event.data.id,
          PolylineHelper.getPolyline(event.data.coordinates),
          event.data.color,
        )
      })
      // edited polygons discarded
      this.registerListener('polygon-discarded', (event) => {
        this.removePolyline(event.data.id)
      })
    },

    async loadPolylines(data) {
      const modifiedRecords = data.records
      await LocationMapPolygonService.getPolylines(
        this.polygonParentAttribute,
        this.polygonParentId,
      ).then((response) => {
        if (response.data) {
          // filter out deleted records
          const polylines = response.data.filter((polyline) => {
            return !modifiedRecords.some((record) => {
              return record.id === polyline.id
            })
          })

          // restore pending records
          modifiedRecords
            .filter((record) => {
              return ['added', 'edited'].includes(record.status)
            })
            .forEach((record) => {
              this.addPolyline(record.id, record.path, record.color)
            })

          this.createPolylines(polylines)
        }
      })
    },

    createPolylines(polylines) {
      polylines.forEach((polyline) => {
        if (this.polylines.has(polyline.id)) {
          return
        }
        this.addPolyline(polyline.id, polyline.path, polyline.color)
      })
    },

    addPolyline(id, path, color) {
      const savedPolyline = new this.google.maps.Polyline({
        path,
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 1.0,
        strokeWeight: 2,
      })
      savedPolyline.setMap(this.map)
      this.removePolyline(id, savedPolyline)
      this.removeHoverPolyline(id)
      // hover polyline
      const hoverPolyline = new this.google.maps.Polyline({
        path,
        geodesic: true,
        strokeColor: color,
        strokeOpacity: 0.001,
        strokeWeight: 20,
      })
      hoverPolyline.setMap(this.map)
      hoverPolyline.addListener('rightclick', (event) => {
        this.$refs.mapContext.onRightClick(event, id, savedPolyline)
      })
      this.addPolygonInfoWindowClickEvent(id, hoverPolyline)
      this.hoverPolylines.set(id, hoverPolyline)
    },

    addPolygonInfoWindowClickEvent(id, polyline) {
      if (!UniqueIdHelper.isTemporaryId(id)) {
        polyline.addListener('click', (event) => {
          LocationMapService.getSummary(id, 'obj.com.bmssolutions.COMPONENT.bms_MapolCo_001').then(
            (summary) => this.openInfoWindow(summary.data, null, event.latLng),
          )
        })
      }
    },

    removePolyline(id, savedPolyline) {
      const existingPolyline = this.polylines.get(id)
      if (existingPolyline) {
        existingPolyline.setMap(null)
      }
      this.polylines.set(id, savedPolyline)
    },

    removeHoverPolyline(id) {
      const existingHoverPolyline = this.hoverPolylines.get(id)
      if (existingHoverPolyline) {
        existingHoverPolyline.setMap(null)
      }
    },

    addPolygonEvent(latLng) {
      this.polygonEvent(`polygon-add`, latLng, null)
    },

    editPolygonEvent(latLng, id) {
      this.polygonEvent(`polygon-edit`, latLng, id)
    },

    deletePolygonEvent(id, polyline) {
      polyline.setMap(null)
      this.removeHoverPolyline(id)
      this.relayEvent({
        event: 'polygon-delete',
        recordId: id,
      })
    },

    polygonEvent(eventName, latLng, id) {
      this.relayEvent({
        event: eventName,
        centreLatitude: latLng.lat(),
        centreLongitude: latLng.lng(),
        initialZoom: this.map.zoom,
        initialMapTypeId: this.map.mapTypeId,
        polygonSubformFieldId: this.polygonSubformFieldId,
        recordId: id,
      })
    },
  },
}
